import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-home-layout',
  imports: [RouterModule, SidenavComponent, HeaderComponent],
  templateUrl: './home-layout.component.html',
})
export class HomeLayoutComponent {}
